/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Text_Square_BracketsInputs */



/**
* | output |
* | --- |
* | "Remove text between [ and ]" |
*
* @param {Remove_Text_Square_BracketsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_text_square_brackets = /** @type {((inputs?: Remove_Text_Square_BracketsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Text_Square_BracketsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le texte entre [ et ]")
	if (locale === "de") return /** @type {LocalizedString} */ ("Entferne den Text zwischen [ und ]")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi il testo tra [ e ]")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалите текст между [ и ]")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar el texto entre [ y ]")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除方括号 [ 和 ] 之间的文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("[と]の間のテキストを削除します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("[ और ] के बीच का टेक्स्ट हटा दें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover texto entre [ e ]")
	return /** @type {LocalizedString} */ ("Remove text between [ and ]")
});